import React from "react";
import { Switch } from "react-router-dom";
import PublicRoute from "./PublicRoute";

// Templates
import Layout from "../components/Layout";

// Routes
import Creator from "../components/Creator";
import ModelSelection from "../components/ModelSelection";
import SubModelSelection from "../components/SubModelSelection";
import Summary from "../components/Summary";
import AdminPanel from "../components/AdminPanel";

const Index = () => (
  <>
    <Switch>
      <PublicRoute
        exact
        path="/"
        component={(props) => (
          <Layout>
            <ModelSelection {...props} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path="/:model/submodel"
        component={(props) => (
          <Layout>
            <SubModelSelection {...props} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path="/creator/:model"
        component={(props) => (
          <Layout>
            <Creator {...props} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path="/creator/:model/:submodel"
        component={(props) => (
          <Layout>
            <Creator {...props} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path="/summary"
        component={(props) => (
          <Layout>
            <Summary {...props} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path="/d3590c2a-bg2f-4gg8-9b57-f22t65698699/admin"
        component={(props) => (
          <Layout>
            <AdminPanel {...props} />
          </Layout>
        )}
      />
    </Switch>
  </>
);

export default Index;
